import resourceFactory from 'common/admin/resourceFactory'

const actions = resourceFactory('buildings')

export default actions
